var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3427 7.53209C11.7607 7.43227 11.1623 7.54162 10.6533 7.84077C10.1443 8.13991 9.75759 8.60955 9.56167 9.16649C9.47003 9.42699 9.18458 9.56387 8.92408 9.47224C8.66359 9.3806 8.5267 9.09514 8.61834 8.83465C8.89262 8.05493 9.43401 7.39744 10.1466 6.97864C10.8592 6.55983 11.697 6.40674 12.5117 6.54648C13.3264 6.68622 14.0653 7.10976 14.5976 7.7421C15.1298 8.37436 15.4212 9.17456 15.42 10.001C15.4198 11.2662 14.4775 12.1465 13.6974 12.6666C13.292 12.9368 12.8903 13.1373 12.5918 13.27C12.4419 13.3366 12.3162 13.3869 12.2269 13.4209C12.1822 13.438 12.1465 13.451 12.1212 13.46L12.0913 13.4704L12.0825 13.4734L12.0798 13.4744L12.0788 13.4747C12.0786 13.4747 12.0781 13.4749 11.92 13.0006L12.0788 13.4747C11.8168 13.562 11.533 13.4207 11.4457 13.1587C11.3584 12.8969 11.4998 12.6139 11.7614 12.5264C11.7616 12.5263 11.7613 12.5264 11.7614 12.5264M11.7614 12.5264L11.7659 12.5248L11.7862 12.5177C11.8049 12.5111 11.8336 12.5007 11.8709 12.4865C11.9456 12.458 12.0544 12.4145 12.1857 12.3562C12.4497 12.2388 12.798 12.0643 13.1427 11.8345C13.8625 11.3547 14.42 10.7351 14.42 10.0006C14.4209 9.41017 14.2128 8.83777 13.8326 8.3861C13.4524 7.93443 12.9246 7.6319 12.3427 7.53209",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 17C11.5 16.7239 11.7239 16.5 12 16.5H12.01C12.2861 16.5 12.51 16.7239 12.51 17C12.51 17.2761 12.2861 17.5 12.01 17.5H12C11.7239 17.5 11.5 17.2761 11.5 17Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help.bc45260ae1b667e016cc48c56af3cdeb.svg";